/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { motion } from "framer-motion";
import { tabandmo } from "styles/media";

interface TitleProps {
  title: React.ReactNode;
  sub?: React.ReactNode;
  theme?: "black" | "white";
}

const Title = ({ title, sub, theme = "black" }: TitleProps) => {
  const titleStyle = css`
    color: ${theme};
    text-align: center;
    .title {
      font-size: 52px;
      line-height: 62px;
      font-weight: 700;
    }
    .sub {
      font-size: 18px;
      line-height: 28px;
      margin-top: 20px;
    }
    ${tabandmo} {
      .title {
        font-size: 32px;
        line-height: 48px;
        letter-spacing: -0.64px;
      }
      .sub {
        font-size: 16px;
        line-height: 24px;
        margin-top: 24px;
      }
    }
  `;
  return (
    <motion.div
      variants={{
        offscreen: {
          y: 100,
          opacity: 0,
        },
        onscreen: {
          y: 0,
          opacity: 1,
          transition: {
            duration: 0.3,
          },
        },
      }}
    >
      <div css={titleStyle}>
        <div className="title">{title}</div>
        {sub && <div className="sub">{sub}</div>}
      </div>
    </motion.div>
  );
};

export default Title;
